import { api, authHeader } from "../configs/axiosConfigs";

const baseBySource = (source) =>
  source === "Management"
    ? "/SLN/Management/PaymentGateway"
    : "/SLN/SolarentOperator/PaymentGateway";

const ManagementPaymentGatewayApi = {
  getHealth: async (source = "Management") => {
    const response = await api.request({
      url: `${baseBySource(source)}/Health`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  getGatewaySummaries: async (source, requestInfoId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/GatewaySummaries/${requestInfoId}`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  resumeSession: async (source, sessionId) => {
    const response = await api.request({
      url: `${baseBySource(source)}/Sessions/${sessionId}/Resume`,
      method: "POST",
      headers: authHeader(),
    });
    return response.data;
  },
};

export default ManagementPaymentGatewayApi;
